import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const FeaturedInitiative = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="bg-gradient-to-br from-primary/10 via-card to-accent/10 border border-border rounded-xl p-6 mb-8"
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-2">
          <div className="w-10 h-10 bg-primary/20 rounded-lg flex items-center justify-center">
            <Icon name="Sparkles" size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">Featured Campaign</h3>
            <p className="text-sm text-muted-foreground">Trending Corporate Initiative</p>
          </div>
        </div>
        <span className="px-3 py-1 bg-primary text-primary-foreground rounded-full text-xs font-semibold">
          Live
        </span>
      </div>
      <div className="mb-4">
        <h4 className="text-xl font-bold text-foreground mb-2">
          Tech Industry Climate Pledge 2025
        </h4>
        <p className="text-sm text-muted-foreground">
          Leading technology companies unite to achieve carbon neutrality and renewable energy targets by end of 2025. 
          Join the movement supporting transparent ESG reporting and sustainable innovation.
        </p>
      </div>
      <div className="flex flex-wrap gap-3 mb-4">
        <div className="flex items-center space-x-2 px-3 py-1 bg-background border border-border rounded-full">
          <Icon name="Building2" size={14} className="text-muted-foreground" />
          <span className="text-sm text-muted-foreground">24 Companies</span>
        </div>
        <div className="flex items-center space-x-2 px-3 py-1 bg-background border border-border rounded-full">
          <Icon name="Target" size={14} className="text-muted-foreground" />
          <span className="text-sm text-muted-foreground">Carbon Neutral Goal</span>
        </div>
        <div className="flex items-center space-x-2 px-3 py-1 bg-background border border-border rounded-full">
          <Icon name="TrendingUp" size={14} className="text-muted-foreground" />
          <span className="text-sm text-muted-foreground">Impact Score: 94</span>
        </div>
      </div>
      <div className="flex gap-3">
        <button className="flex-1 py-2 px-4 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors flex items-center justify-center space-x-2">
          <Icon name="ExternalLink" size={14} />
          <span>Learn More</span>
        </button>
        <button className="py-2 px-4 bg-background border border-border text-foreground rounded-lg text-sm font-medium hover:bg-muted transition-colors flex items-center justify-center space-x-2">
          <Icon name="Share2" size={14} />
        </button>
      </div>
    </motion.div>
  );
};

export default FeaturedInitiative;